var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5533 7.99119L13.5513 7.51906C13.535 5.64642 13.4222 3.97565 13.2275 2.91683C13.2275 2.89774 13.0151 1.84762 12.8798 1.49807C12.6675 0.99284 12.2835 0.56398 11.802 0.292271C11.4166 0.0984028 11.0122 0 10.589 0C10.2562 0.0154213 9.70752 0.182853 9.31589 0.323228L8.99044 0.447953C6.83483 1.3042 2.71415 4.10208 1.13599 5.81311L1.01964 5.93271L0.500358 6.49312C0.173089 6.92198 0 7.4463 0 8.01028C0 8.51551 0.15418 9.02075 0.46254 9.42904C0.554854 9.56132 0.703552 9.73103 0.835905 9.87442L1.34133 10.4035C3.08061 12.1657 6.84646 14.6376 8.79844 15.4566C8.79844 15.4742 10.0115 15.9809 10.589 16H10.6661C11.5519 16 12.3795 15.4948 12.8028 14.6782C12.9184 14.4549 13.0293 14.0176 13.1137 13.6336L13.2653 12.9084C13.4384 11.7422 13.5533 9.95337 13.5533 7.99119ZM21.9955 10.0245C23.1024 10.0245 23.9999 9.11827 23.9999 8.00059C23.9999 6.88291 23.1024 5.97673 21.9955 5.97673L17.0632 6.41293C16.1949 6.41293 15.4909 7.12231 15.4909 8.00059C15.4909 8.87741 16.1949 9.58825 17.0632 9.58825L21.9955 10.0245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.e213cce10769c924bb2b2acde2673165.svg";
export { ForwardRef as ReactComponent };